var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: [_vm.bemBlock, { "visually-hidden": _vm.hidden }, "pdp-link"] },
    [
      _c(
        "a",
        {
          class: [_vm.bemElement("link", { clamp: _vm.lineClamp > 0 }), "link"],
          attrs: { draggable: "false", href: _vm.url },
          on: {
            click: _vm.handleLinkClick,
            dragstart: function($event) {
              $event.preventDefault()
              return _vm.dragDisabled($event)
            }
          }
        },
        [
          _c(
            "h2",
            { attrs: { itemprop: "name" } },
            [
              _vm.lineClamp > 0
                ? [
                    _c(
                      "v-clamp",
                      { attrs: { autoresize: "", "max-lines": _vm.lineClamp } },
                      [_vm._v(_vm._s(_vm.productName))]
                    )
                  ]
                : [_vm._v("\n        " + _vm._s(_vm.productName) + "\n      ")]
            ],
            2
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }